import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Displays the duration of the licence of a sensor.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmDuration = (classes, props = {}) => {
  const { duration = '-' } = props

  return (
    <Text
      color={'black'}
      variant={'14/medium'}
      className={classes.row}
    >
      {duration}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmDuration)
